// extracted by mini-css-extract-plugin
module.exports = {"center":"ModalHub_center__2QEt2","backdrop":"ModalHub_backdrop__elMMp"};